var exports = {
  "x": "xdde3148b--84cd56--button",
};

module.exports = exports;
